import script from "./BookingSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingSearch.vue?vue&type=script&setup=true&lang=ts"

import "./BookingSearch.vue?vue&type=style&index=0&id=3451915c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3451915c"]])

export default __exports__